import { useQuery } from "react-query";
import { getRetailOffices } from "actions/CarrierAgreementMgmt/OfficeSettings";
export const useGetRetailOffices = () => {
  return useQuery(
    "GetRetailOffices",
    getRetailOffices,
    {
      refetchOnWindowFocus: false,
    }
  );
};
